import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import App from './App';
//import reportWebVitals from './reportWebVitals';
import "bootstrap-icons/font/bootstrap-icons.css"; 
import 'bootstrap/dist/css/bootstrap.min.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { BrowserRouter } from 'react-router-dom';
import AuthProvider from './AuthProvider'
import ContactModel from './homepage/globalPopup/ContactModel';

// Back-compat: convert old HashRouter URLs like /#/career into /career
if (window.location.hash && window.location.hash.startsWith('#/')) {
  window.history.replaceState(null, '', window.location.hash.slice(1));
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
  {/* { let times = setTimeout(()=>{
   
  }, 2000)
  clearTimeOut(times)
  } */}
  <ContactModel/>
  <AuthProvider>
  <BrowserRouter>
 
    <App />
    </BrowserRouter>
    </AuthProvider>
    </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
